import { HTTP_CODE } from '@/utils/request'
import * as service from './service'
import Toast from 'antd-mobile/es/toast'
export default {
  namespace: 'propMyPropBag',
  state: {
    demoData: {}
  },
  effects: {
    * getPropList ({ payload }, { call, put }) {
      const res = yield call(service.courierPropList, payload)
      if (res.status !== HTTP_CODE.success) {
        console.error(res.data.err)
      }
      return res.data
    },
    * useProp ({ payload }, { call, put }) {
      try {
        const res = yield call(service.useProp, payload)
        if (res.status !== HTTP_CODE.success) {
          console.error(res.data.err)
        }
        return res.data
      } catch (error) {
        console.log(error, 'errorerror')
      }
    },
    * stopProp ({ payload }, { call, put }) {
      try {
        const res = yield call(service.stopProp, payload)
        if (res.status !== HTTP_CODE.success) {
          console.error(res.data.err)
        }
        return res.data
      } catch (error) {
        console.log(error, 'errorerror')
      }
    },
    * checkPropAllowUse ({ payload }, { call, put }) {
      try {
        const res = yield call(service.checkPropAllowUse, payload)
        if (res.status !== HTTP_CODE.success) {
          console.error(res.data.err)
        }
        return res.data
      } catch (error) {
        console.log(error, 'errorerror')
      }
    },
    * getActivityData ({ payload }, { call, put }) {
      const res = yield call(service.getActivityData, payload)
      yield put({
        type: 'save',
        payload: {
          getActivityData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
